var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.idModal,
            size: "xl",
            title:
              _vm.titreModal +
              (_vm.action === "out" && _vm.quantiteDisponible
                ? " - Quantité disponible en stock : " +
                  _vm.quantiteDisponible +
                  " " +
                  _vm.lot.uc
                : ""),
            "ok-title": "Enregistrer",
            "ok-disabled":
              !_vm.$v.typeMouvement.required ||
              !_vm.$v.quantite.required ||
              !_vm.$v.quantite.$model ||
              !_vm.$v.dateMouvement.required ||
              !_vm.$v.article.required ||
              !_vm.$v.serviceId.required ||
              !_vm.$v.menuPlanId.required ||
              !_vm.$v.dateConsommation.required ||
              !_vm.$v.commentaire.required,
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: {
            show: function($event) {
              return _vm.initArticle()
            },
            ok: function($event) {
              return _vm.envoyer()
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _vm.lot
              ? _c("div", [
                  _c("h5", [
                    _vm._v(
                      "Article : " + _vm._s(_vm.lot.designationFournisseur)
                    )
                  ])
                ])
              : _c(
                  "div",
                  [
                    _c("RechercheArticles", {
                      on: {
                        "change-ingredient": function($event) {
                          return _vm.changeIngredient($event)
                        },
                        "change-state": function($event) {
                          return _vm.changeEtatRecherche($event)
                        }
                      }
                    }),
                    _vm.stateSearch
                      ? _c(
                          "h5",
                          {
                            key: _vm.stateSearch,
                            staticClass: "push-top-1rem"
                          },
                          [_vm._v(_vm._s(_vm.stateSearch))]
                        )
                      : _vm._e(),
                    _vm.ingredient && _vm.ingredient.parProduit
                      ? _c("ArticlesParProduit", {
                          attrs: {
                            articles: _vm.ingredient.parProduit,
                            favoris: _vm.ingredient.favoris
                          },
                          on: {
                            "selection-article": function($event) {
                              return _vm.setArticle($event)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.article && _vm.article.designation
                      ? _c("h5", { staticClass: "push-top-1rem" }, [
                          _vm._v("Article : " + _vm._s(_vm.article.designation))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.article.tarifId,
                    expression: "article.tarifId"
                  }
                ],
                staticClass: "card"
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _vm.article.tarifId
                    ? _c("div", { staticClass: "flex-center" }, [
                        _c("div", { staticClass: "col-4 flex-start" }, [
                          _c(
                            "div",
                            { staticClass: "label-input push-right-1rem" },
                            [_vm._v("N° Lot : ")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.NumLot,
                                expression: "NumLot"
                              }
                            ],
                            attrs: {
                              type: "text",
                              disabled: _vm.action === "out"
                            },
                            domProps: { value: _vm.NumLot },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.NumLot = $event.target.value
                              }
                            }
                          })
                        ]),
                        _c("div", { staticClass: "col-4 flex-start" }, [
                          _c(
                            "div",
                            { staticClass: "flex-center-space-between" },
                            [
                              _c("b-input-group", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.action === "out",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false",
                                      title:
                                        !_vm.dlc &&
                                        "Date de Durabilité Minimale (ex. DLUO)"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.dlc ? "DLC" : "DDM") +
                                        " "
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          _vm.dlc = true
                                        }
                                      }
                                    },
                                    [_vm._v("DLC")]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          _vm.dlc = false
                                        }
                                      }
                                    },
                                    [_vm._v("DDM")]
                                  )
                                ])
                              ]),
                              _c("v-date-picker", {
                                staticClass: "date-picker",
                                attrs: {
                                  disabled: _vm.action === "out",
                                  columns: 1,
                                  step: 1,
                                  popover: { visibility: "click" }
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setDateDlcDluo()
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var inputValue = ref.inputValue
                                        var inputEvents = ref.inputEvents
                                        return [
                                          _c(
                                            "input",
                                            _vm._g(
                                              {
                                                domProps: {
                                                  value: inputValue
                                                    ? inputValue
                                                    : _vm.dlc
                                                    ? "DLC..."
                                                    : "DDM..."
                                                }
                                              },
                                              inputEvents
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  357252409
                                ),
                                model: {
                                  value: _vm.dlcDluo,
                                  callback: function($$v) {
                                    _vm.dlcDluo = $$v
                                  },
                                  expression: "dlcDluo"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-4 flex-end" },
                          [
                            _c(
                              "div",
                              { staticClass: "label-input push-right-1rem" },
                              [_vm._v("PU HT :")]
                            ),
                            _c("InputNumber", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content: "Prix Unitaire",
                                    placement: "top"
                                  },
                                  expression:
                                    "{ content: 'Prix Unitaire', placement: 'top' }"
                                }
                              ],
                              staticStyle: { width: "100px" },
                              attrs: {
                                disabled: _vm.action === "out",
                                typeFiltre: "montant"
                              },
                              model: {
                                value: _vm.valeurUnitaire,
                                callback: function($$v) {
                                  _vm.valeurUnitaire = $$v
                                },
                                expression: "valeurUnitaire"
                              }
                            }),
                            _c("div", { staticClass: "label-input ml-1" }, [
                              _vm._v("€")
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "flex-center push-top-1rem" }, [
                    _vm.mode === "stock"
                      ? _c(
                          "div",
                          { staticClass: "col-4 flex-start" },
                          [
                            _vm.action === "in"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "label-input push-right-1rem"
                                  },
                                  [_vm._v("Entrée au : ")]
                                )
                              : _vm._e(),
                            _vm.action === "out"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "label-input push-right-1rem"
                                  },
                                  [_vm._v("Sortie au : ")]
                                )
                              : _vm._e(),
                            _c("v-date-picker", {
                              attrs: {
                                "disabled-dates": _vm.datesInvalides,
                                popover: { visibility: "click" }
                              },
                              on: {
                                input: function($event) {
                                  return _vm.setDateMouvement($event)
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var inputValue = ref.inputValue
                                      var inputEvents = ref.inputEvents
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-col sm:flex-row justify-start items-center"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative flex-grow"
                                              },
                                              [
                                                _c(
                                                  "input",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "flex-grow pl-8 pr-5 py-1 bg-gray-100 border rounded w-full text-gray-900",
                                                      staticStyle: {
                                                        height: "40px"
                                                      },
                                                      domProps: {
                                                        value: inputValue
                                                          ? inputValue
                                                          : "Choisir la date..."
                                                      }
                                                    },
                                                    inputEvents
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2576489867
                              ),
                              model: {
                                value: _vm.dateMouvement,
                                callback: function($$v) {
                                  _vm.dateMouvement = $$v
                                },
                                expression: "dateMouvement"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.mode === "stock"
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("b-form-radio-group", {
                              attrs: { options: _vm.optionsTypeMouvement },
                              on: { change: _vm.typeMouvementChange },
                              model: {
                                value: _vm.typeMouvement,
                                callback: function($$v) {
                                  _vm.typeMouvement = $$v
                                },
                                expression: "typeMouvement"
                              }
                            }),
                            !_vm.$v.typeMouvement.required
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(" Ce champ est requis ")
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "col-4",
                        class:
                          _vm.mode === "stock" ? " flex-end" : " flex-start"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "label-input push-right-1rem" },
                          [_vm._v("Quantité :")]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "flex-center" },
                            [
                              _c("InputNumber", {
                                key: _vm.keyQuantite,
                                ref: "quantite",
                                staticStyle: { "max-width": "130px" },
                                attrs: {
                                  typeFiltre: "quantite",
                                  disabled: this.razQuantite
                                },
                                on: {
                                  move: function($event) {
                                    return _vm.moveQte($event)
                                  }
                                },
                                model: {
                                  value: _vm.$v.quantite.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.quantite,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "$v.quantite.$model"
                                }
                              }),
                              _c("div", { staticClass: "push-left-1rem" }, [
                                _vm.ingredient.uc
                                  ? _c("span", [
                                      _vm._v(
                                        " " + _vm._s(_vm.ingredient.uc) + " "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm.action === "out"
                                ? _c("div", { staticClass: "flex-end ml-2" }, [
                                    _vm._v(" ( "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content:
                                                "Vide le stock pour cet article",
                                              placement: "top"
                                            },
                                            expression:
                                              "{ content: 'Vide le stock pour cet article', placement: 'top' }"
                                          }
                                        ],
                                        staticClass:
                                          "custom-control custom-checkbox ml-2"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.razQuantite,
                                              expression: "razQuantite"
                                            }
                                          ],
                                          staticClass:
                                            "custom-control-input cursor-pointer",
                                          attrs: {
                                            id: "raz",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.razQuantite
                                            )
                                              ? _vm._i(_vm.razQuantite, null) >
                                                -1
                                              : _vm.razQuantite
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.razQte()
                                            },
                                            change: function($event) {
                                              var $$a = _vm.razQuantite,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.razQuantite = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.razQuantite = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.razQuantite = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "custom-control-label cursor-pointer mr-1",
                                            attrs: { for: "raz" }
                                          },
                                          [_vm._v("RàZ")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" ) ")
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          !_vm.$v.quantite.required
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v(" Ce champ est requis ")
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ]),
                  _vm.action === "out" && _vm.article.tarifId
                    ? _c(
                        "div",
                        { staticClass: "flex-center push-top-1rem mb-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("label", { attrs: { for: "datesMenus" } }, [
                                _vm._v(
                                  "Choisir le jour de la consommation à partir du menu :"
                                )
                              ]),
                              _c("SelectDatesMenusPlansServices", {
                                attrs: {
                                  id: "datesMenus",
                                  multiSelect: false,
                                  multiDates: false,
                                  disabled: !_vm.sortieJournee,
                                  dateDebut: _vm.optionsSortieStock.dateDebut,
                                  dateFin: _vm.optionsSortieStock.dateFin,
                                  menuPlanIds:
                                    _vm.optionsSortieStock.menusPlansIds,
                                  serviceIds:
                                    _vm.optionsSortieStock.servicesIds,
                                  viderMenusPlans: "Vider"
                                },
                                on: {
                                  "changer-dms": function($event) {
                                    return _vm.changerParametresMenus($event)
                                  }
                                }
                              }),
                              !_vm.$v.serviceId.required ||
                              !_vm.$v.menuPlanId.required ||
                              !_vm.$v.dateConsommation.required
                                ? _c("div", { staticClass: "error" }, [
                                    _vm._v(" Ces champs sont requis ")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "flex-center push-top-1rem" }, [
                    _vm.mode === "stock"
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("b-form-textarea", {
                              staticStyle: { height: "100px" },
                              attrs: {
                                placeholder: "Commentaire...",
                                rows: "4",
                                "max-rows": "4"
                              },
                              model: {
                                value: _vm.commentaire,
                                callback: function($$v) {
                                  _vm.commentaire = $$v
                                },
                                expression: "commentaire"
                              }
                            }),
                            !_vm.$v.commentaire.required
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(" Ce champ est requis ")
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }